import { createBrowserRouter } from 'react-router-dom'
import sponsorRoutes from './sponsorRoutes'
import licenseRoutes from './licenseRoutes'
import holderRoutes from './holderRoutes'
import customerRoutes from './customerRoutes'
import authUserRoutes from './authUserRoutes'
import livoxUserRoutes from './livoxUserRoutes'
import cloudStoreRoutes from './cloudStoreRoutes'
import paymentRoutes from './paymentRoutes'
import supportAreasRoutes from './supportAreasRoutes'
import androidVersionsRoutes from './androidVersionsRoutes'
import resellersRoutes from './resellersRoutes'

export const PORTAL_ADMIN = 'Portal Admin'
export const PORTAL_SUPPORT = 'Portal Support'
export const DISTRIBUTOR_ADMIN = 'Distributor Admin'
export const DISTRIBUTOR_SUPPORT = 'Distributor Support'
export const CUSTOMER_ADMIN = 'Customer Admin'
export const CUSTOMER_SUPPORT = 'Customer Support'
export const HOLDER = 'Holder'
export const LIVOX_USER = 'Livox User'
export const SPONSOR = 'Sponsor'

const router = createBrowserRouter([
  ...paymentRoutes,
  ...authUserRoutes,
  ...cloudStoreRoutes,
  ...customerRoutes,
  ...holderRoutes,
  ...licenseRoutes,
  ...livoxUserRoutes,
  ...sponsorRoutes,
  ...supportAreasRoutes,
  ...androidVersionsRoutes,
  ...resellersRoutes,
])

export default router
